"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapColumnRenderer = exports.IsRowSelectTableInstance = exports.IsRowSelectTableState = exports.AddStyles = exports.AddCssClass = exports.IsSortableColumn = exports.IsSelectableRow = void 0;
function IsSelectableRow(row) {
    return typeof row.isSelected === "boolean";
}
exports.IsSelectableRow = IsSelectableRow;
function IsSortableColumn(column) {
    return !!column.canSort;
}
exports.IsSortableColumn = IsSortableColumn;
function AddCssClass(props, newClassName) {
    return Object.assign(Object.assign({}, props), { className: props.className ? `${props.className} ${newClassName}` : newClassName });
}
exports.AddCssClass = AddCssClass;
function AddStyles(props, style) {
    return Object.assign(Object.assign({}, props), { style: Object.assign(Object.assign({}, (props.style || {})), style) });
}
exports.AddStyles = AddStyles;
function IsRowSelectTableState(state) {
    return !!state.selectedRowIds;
}
exports.IsRowSelectTableState = IsRowSelectTableState;
function IsRowSelectTableInstance(instance) {
    return !!instance.selectedFlatRows;
}
exports.IsRowSelectTableInstance = IsRowSelectTableInstance;
function WrapColumnRenderer(column, renderer, onlyWrap) {
    const originalRender = column.render;
    column.render = (type, props) => {
        if (!onlyWrap || onlyWrap === type) {
            return renderer(() => originalRender(type, props));
        }
        else {
            return originalRender(type, props);
        }
    };
}
exports.WrapColumnRenderer = WrapColumnRenderer;
//# sourceMappingURL=utilities.js.map